var map = {
	"./agendas.png": 3145,
	"./agendas_angle.png": 6053,
	"./agendas_detail.png": 3277,
	"./agendas_var.png": 8731,
	"./arrow.svg": 7933,
	"./badge.png": 9655,
	"./badge_detail_new.png": 8440,
	"./badge_stack_new.png": 2341,
	"./badges_usage.png": 4464,
	"./bag.svg": 4044,
	"./bookmark-1.png": 8282,
	"./bookmark-2.png": 8177,
	"./bookmark-3.png": 6136,
	"./books_hero.png": 9537,
	"./books_open.png": 825,
	"./brochure_cover_angle_1769358335257.png": 7403,
	"./brochure_main_hero_1769364501452.png": 7831,
	"./brochure_open_pages_1769358320785.png": 4501,
	"./brochure_stack_spine_1769358349933.png": 7640,
	"./business_card_detail_1769358219462.png": 9081,
	"./business_card_fan_1769358204779.png": 4974,
	"./business_card_main_hero_1769364457825.png": 9568,
	"./business_card_stack_1769358189785.png": 8902,
	"./calendar.svg": 2340,
	"./calendars_desk.png": 8787,
	"./calendars_detail.png": 1503,
	"./calendars_hero.png": 4176,
	"./calendars_wall.png": 7220,
	"./cart.svg": 7944,
	"./catalogue_detail_v2_1770054347246.png": 1507,
	"./catalogue_img_3.png": 6843,
	"./catalogue_main_hero_1769364514707.png": 8937,
	"./catalogue_open_v2_1770054295903.png": 2268,
	"./certificates_angle.png": 7036,
	"./certificates_hero.png": 6473,
	"./certificates_stack.png": 3273,
	"./coated_bag_angle_1770924667012.png": 128,
	"./coated_bag_front_1770924633258.png": 9117,
	"./coated_bag_side_1770924650751.png": 1300,
	"./delivery.svg": 486,
	"./dollar.svg": 8912,
	"./edit.svg": 7322,
	"./email-dark.svg": 8651,
	"./email.svg": 4426,
	"./envelope_detail_1770050567071.png": 3419,
	"./envelope_hero_1770050509184.png": 9653,
	"./envelope_open_1770050549665.png": 1921,
	"./envelope_stack_1770050527920.png": 6919,
	"./facebook.svg": 6338,
	"./flyer_designed_detail_1769363336344.png": 23,
	"./flyer_designed_floating_1769363318143.png": 5567,
	"./flyer_designed_stack_1769363299545.png": 791,
	"./flyer_main_hero_1769364473917.png": 669,
	"./folders_hero.png": 6686,
	"./folders_inside.png": 5042,
	"./folders_open.png": 3094,
	"./folders_stack.png": 4908,
	"./hero.png": 5284,
	"./id_card_1.png": 670,
	"./id_card_2.png": 4677,
	"./id_card_3.png": 1788,
	"./image1.webp": 5506,
	"./image10.webp": 2398,
	"./image11.webp": 3833,
	"./image12.webp": 796,
	"./image13.webp": 1039,
	"./image14.webp": 7810,
	"./image15.webp": 3373,
	"./image16.webp": 5056,
	"./image17.webp": 5459,
	"./image18.webp": 6454,
	"./image19.webp": 1297,
	"./image2.webp": 3155,
	"./image20.webp": 8389,
	"./image3.webp": 2752,
	"./image4.webp": 7881,
	"./image5.webp": 94,
	"./image6.webp": 8735,
	"./image7.webp": 8492,
	"./image8.webp": 789,
	"./image9.webp": 8922,
	"./instagram.svg": 1574,
	"./invitation_detail_1770051447363.png": 2578,
	"./invitation_envelope_1770051421790.png": 4179,
	"./invitation_hero_1770051376119.png": 345,
	"./invitation_stack_1770051401160.png": 2612,
	"./kraft-bag-1.png": 1603,
	"./kraft-bag-2.png": 9640,
	"./kraft-bag-3.png": 769,
	"./kraft-bag-4.png": 2286,
	"./lamination.svg": 1488,
	"./launch.svg": 9903,
	"./leaflet_main_hero_1769364487378.png": 8804,
	"./leaflet_open_1769358276625.png": 260,
	"./leaflet_stack_folded_1769358289075.png": 2086,
	"./leaflet_standing_1769358303356.png": 6444,
	"./letterhead_detail_1769434317580.png": 281,
	"./letterhead_flat_angle_1769434333252.png": 6743,
	"./letterhead_hero_1769434386464.png": 351,
	"./letterhead_stack_1769434302151.png": 3070,
	"./linkedin.svg": 7464,
	"./location-dark.svg": 5912,
	"./location.svg": 9915,
	"./logo.png": 3153,
	"./logoyellow.png": 529,
	"./menu_detail_designed_1769363383052.png": 2564,
	"./menu_flat_designed_1769363368734.png": 414,
	"./menu_mockup_1769306044938.png": 9618,
	"./menu_open_designed_1769363351831.png": 6335,
	"./menus_folded.png": 609,
	"./menus_folded_angle.png": 2013,
	"./menus_folded_detail.png": 5461,
	"./menus_folded_var.png": 5507,
	"./menus_single.png": 2135,
	"./menus_single_angle.png": 3319,
	"./menus_single_detail.png": 7459,
	"./menus_single_var.png": 1397,
	"./menus_tent.png": 7848,
	"./menus_tent_angle.png": 2552,
	"./menus_tent_detail.png": 4522,
	"./menus_tent_var.png": 2166,
	"./notebooks_detail.png": 9782,
	"./notebooks_hero.png": 5433,
	"./notebooks_open.png": 7633,
	"./notebooks_stack.png": 8617,
	"./offer1.png": 6675,
	"./offer2.png": 4696,
	"./offer3.png": 3089,
	"./packaging.svg": 3879,
	"./palette.svg": 1575,
	"./paper.svg": 9316,
	"./paperside.svg": 7037,
	"./partner1.png": 3975,
	"./partner2.png": 6940,
	"./partner3.png": 8565,
	"./partner4.png": 6506,
	"./partner5.png": 6339,
	"./partner6.webp": 2806,
	"./partner7.webp": 8913,
	"./partner8.webp": 2720,
	"./partner9.svg": 2669,
	"./phone-number.png": 9590,
	"./phone.svg": 8382,
	"./postcard_fan_designed_1769363455795.png": 4611,
	"./postcard_flat_designed_1769363470562.png": 4416,
	"./postcard_mockup_1769341055587.png": 1046,
	"./postcard_stack_designed_1769363440340.png": 1166,
	"./poster_angle_new.png": 9560,
	"./poster_detail_new.png": 604,
	"./poster_hero_new.png": 7327,
	"./poster_variation_new.png": 5058,
	"./power.svg": 4769,
	"./prescription_pad_1.png": 526,
	"./prescription_pad_2.png": 2629,
	"./prescription_pad_3.png": 364,
	"./prescription_pad_hero.png": 9591,
	"./printing.svg": 6985,
	"./profile-icon.svg": 7025,
	"./quality.svg": 317,
	"./scissors.svg": 251,
	"./search.svg": 8246,
	"./self_carbon_notebook_1.png": 182,
	"./self_carbon_notebook_2.png": 1389,
	"./self_carbon_notebook_3.png": 7879,
	"./softcover_catalog_stack.png": 3370,
	"./star.svg": 9718,
	"./store.svg": 6177,
	"./time.svg": 4481,
	"./trash.svg": 3352,
	"./truck.svg": 4615,
	"./upload.svg": 8277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1877;